import type { UserProfileDraftDto } from "@/modules/users/gateway/usersDto"
import { useServicesContext } from "@/modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { usersKeys } from "@/modules/users/gateway/usersKeys"
import { useAppStateActions } from "@/modules/auth/store/useAppStateStore"
import { UserProfileEntity } from "@/modules/users/entities/usersEntity"

export function useRegisterUser() {
  const { userProfileApi } = useServicesContext()
  const queryClient = useQueryClient()
  const { setAppStateUser } = useAppStateActions()

  return useMutation({
    mutationFn: async (draft: Partial<UserProfileDraftDto>) => {
      const user = await userProfileApi.register(draft)
      return user
    },
    onSuccess: (user) => {
      queryClient.setQueryData(usersKeys.me(), user)
      setAppStateUser({ user: UserProfileEntity.fromDto(user) })
    },
  })
}
